import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutPageTwoComponent } from './components/pages/about-page-two/about-page-two.component';
import { InstructorsPageOneComponent } from './components/pages/instructors-page-one/instructors-page-one.component';
import { InstructorsPageTwoComponent } from './components/pages/instructors-page-two/instructors-page-two.component';
import { EventsPageComponent } from './components/pages/events-page/events-page.component';
import { EventsDetailsPageComponent } from './components/pages/events-details-page/events-details-page.component';
import { GalleryPageComponent } from './components/pages/gallery-page/gallery-page.component';
import { FeedbackPageComponent } from './components/pages/feedback-page/feedback-page.component';
import { PartnerPageComponent } from './components/pages/partner-page/partner-page.component';
import { LoginPageComponent } from './components/pages/login-page/login-page.component';
import { RegisterPageComponent } from './components/pages/register-page/register-page.component';
import { FaqPageComponent } from './components/pages/faq-page/faq-page.component';
import { ErrorPageComponent } from './components/pages/error-page/error-page.component';
import { ComingSoonPageComponent } from './components/pages/coming-soon-page/coming-soon-page.component';
import { BlogFullWidthPageComponent } from './components/pages/blog-full-width-page/blog-full-width-page.component';
import { BlogDetailsPageComponent } from './components/pages/blog-details-page/blog-details-page.component';
import { CheckoutPageComponent } from './components/pages/checkout-page/checkout-page.component';
import { ContactPageComponent } from './components/pages/contact-page/contact-page.component';
import { CategoryPageOneComponent } from './components/pages/category-page-one/category-page-one.component';
import { CategoryPageTwoComponent } from './components/pages/category-page-two/category-page-two.component';
import { CoursesListPageComponent } from './components/pages/courses-list-page/courses-list-page.component';
import { CoursesGridStyleOneColumnsThreePageComponent } from './components/pages/courses-grid-style-one-columns-three-page/courses-grid-style-one-columns-three-page.component';
import { CoursesDetailsPageComponent } from './components/pages/courses-details-page/courses-details-page.component';
import { HomePageThirteenComponent } from './components/pages/home-page-thirteen/home-page-thirteen.component';

const routes: Routes = [
    {path: '', component: HomePageThirteenComponent},
    // {path: 'online-education-course', component: HomePageThirteenComponent},
    // {path: 'about-style-2', component: AboutPageTwoComponent},
    // {path: 'instructor-1', component: InstructorsPageOneComponent},
    // {path: 'instructor-2', component: InstructorsPageTwoComponent},
    // {path: 'gallery', component: GalleryPageComponent},
    {path: 'events', component: EventsPageComponent},
    {path: 'detail-event/:code', component: EventsDetailsPageComponent},
    // {path: 'feedback', component: FeedbackPageComponent},
    // {path: 'partner', component: PartnerPageComponent},
    // {path: 'login', component: LoginPageComponent},
    // {path: 'register', component: RegisterPageComponent},
    // {path: 'faqs', component: FaqPageComponent},
    {path: 'error-404', component: ErrorPageComponent},
    {path: 'coming-soon', component: ComingSoonPageComponent},
    // {path: 'courses-category-style-1', component: CategoryPageOneComponent},
    // {path: 'courses-category-style-2', component: CategoryPageTwoComponent},
    // {path: 'courses-list', component: CoursesListPageComponent},
    {path: 'offers', component: CoursesGridStyleOneColumnsThreePageComponent},
    // {path: 'courses-3-columns-style-1', component: CoursesGridStyleOneColumnsThreePageComponent},
    // {path: 'single-courses', component: CoursesDetailsPageComponent},
    // {path: 'blog-style-3', component: BlogFullWidthPageComponent},
    // {path: 'single-blog', component: BlogDetailsPageComponent},
    // {path: 'checkout', component: CheckoutPageComponent},
    {path: 'contact', component: ContactPageComponent},
    // Here add new pages component
    
    {path: '**', component: ErrorPageComponent} // This line will remain down from the whole pages component list
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }